/* eslint-disable react-hooks/exhaustive-deps */
import {
  Box,
  HStack,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Tooltip
} from '@chakra-ui/react';
import {
  Heading,
  TextInput,
  useCQMediaQuery,
  usePaginationSessionStorage,
  useTabStorage,
} from '@laxmimanogna/code-quick-components';
import React, { use, useContext, useEffect, useMemo, useState } from 'react';
import CQContainer from '../../components/layout/CQContainer';
import { FONT_FAMILY } from '../../constants/Theme';
import MyAuditProvider, {
  MyAuditContext,
} from '../../providers/MyAuditProvider';
import RecentAudits from './components/RecentAudits';
import { withMultiProviders, withProvider } from '../../hoc/withProvider';
import AllAuditTable from './components/table/AllAuditTable';
import NewUploads from './components/table/NewUploads';
import ArchivedTable from './components/table/ArchivedTable';
import RebuttalTable from './components/table/RebuttalTable';
import Urgent from './components/table/Urgent';
import AppColors from '../../constants/AppColors';
import { SearchIcon } from '@chakra-ui/icons';
import { UrgentIcon } from '../../constants/IconData';
import Select from 'react-select';
import { CustomTab } from '../../components/CustomTab';
import NewAuditTable from './components/table/NewAuditTable';
import AuditSheetProvider, { AuditSheetContext } from '../../providers/AuditSheetProvider';
import { FILTER_OPTIONS, FILTER_OPTIONS_TO_CHART_STATUS_MAP } from '../../constants/constants';
import { DASHBOARD_PAGE_NAME, DASHBOARD_TABLE_NAME } from './constants';

const DropdownComponent = ({
  options,
  setSelected,
  selected,
  placeholder = "Select Options",
  isDisabled=false,
  disabledText = "Dropdown disabled",
  isLoading=false,
  isClearable=true,
  isSearchable=true
}) => {
  const handleChange = (option) => {
    setSelected(option);
  }

  return (
    <div
    style={{
      flex:1,
    }}>
      <Select 
      options={options}
      onChange={handleChange}
      isClearable={isClearable}
      placeholder={placeholder}
      isDisabled={isDisabled}
      value={selected}
      isLoading={isLoading}
      isSearchable={isSearchable}
      />
    </div> 
  )
}

const DashboardContainerV2 = props => {
  // states
  const {
    getPaginationSession
  } = usePaginationSessionStorage();
  const [onSearchText, setSearchText] = useState(getPaginationSession(DASHBOARD_PAGE_NAME, DASHBOARD_TABLE_NAME)?.search || '');
  const tabStorage = useTabStorage();
  const [selectedTab, setSelectedTab] = useState(0);
  const auditSheetContext = useContext(AuditSheetContext)

  useEffect(() => {tabStorage.setTab(selectedTab)}, [selectedTab]);

  // other hooks
  const marginHorizontal = useCQMediaQuery({
    lg: '12%',
    md: '6%',
    sm: '2%',
  });

  // context
  const myAuditContext = useContext(MyAuditContext);
  const {
    auditUrgentListCount,
    getRecentAudits,
    handleApplyFilter,
    filterParams,
    getAllCharts,
    chartStatusFilters,
    setChartStatusFilters,
    isAllChartsLoading
  } = myAuditContext;

  const onSearchAction = () => {
    handleApplyFilter({ ...filterParams, searchText: onSearchText });
  };

  const onFilterChange = e => {
    if (e) {
      setSearchText(e.target.value);
    } else {
      setSearchText('');
    }
  };

  

  const auditorPortalTabs = [
    {
      title: 'Charts',
      header: 'Charts',
      component: NewAuditTable,
    },
  ];

  // life-cycle hooks
  useEffect(() => {
    getRecentAudits();
  }, []);

  const dropdownOptions = useMemo(
    () => FILTER_OPTIONS.map(val => ({ value: val, label: val })),
    [FILTER_OPTIONS]
  );

  const [selectedFilter, setSelectedFilter] = useState(() => ({
    value: FILTER_OPTIONS[tabStorage.getTab() || 0],
    label: FILTER_OPTIONS[tabStorage.getTab() || 0]
  }));

  useEffect(() => {
    if (!selectedFilter.value) {
      return;
    }
    tabStorage.setTab(FILTER_OPTIONS.indexOf(selectedFilter.value))
  }, [selectedFilter]);

  const onOpenNotes = (obj, batchId, tabType = undefined) => {
    if (obj && Object.keys(obj).length) {
      if (obj.all) {
        delete auditSheetContext.commentFilters.sheet_name
        auditSheetContext.setCommentFilters({
          ...auditSheetContext.commentFilters,
          page: 1,
          tabType: tabType
        })
      } else if (obj.current) {
        auditSheetContext.setCommentFilters({
          ...auditSheetContext.commentFilters,
          sheet_name: "Sheet1",
          page: 1,
          tabType: tabType
        })
      }
    } else {
      auditSheetContext.setCommentFilters({
        ...auditSheetContext.commentFilters,
        batchId,
        sheet_name: "Sheet1",
        reverse: true,
        page: 1,
        tabType: tabType
      })
    }
  }

  return (
    <Box>
      <Box py={5} height={250} bg={'white'} px={marginHorizontal}>
        <Heading
          fontSize={'24px'}
          fontFamily={FONT_FAMILY.baiJamurjee}
          fontWeight="bold"
        >
          Recent Audits
        </Heading>
        <RecentAudits />
      </Box>
      <CQContainer>
        <Heading my={5} fontSize={'xl'}>
          {auditorPortalTabs[selectedTab].header}
        </Heading>
        <Box
          shadow={'md'}
          bg="white"
          p={4}
          w="100%"
          style={{ borderRadius: '12px' }}
        >
          <Tabs
            fontFamily={FONT_FAMILY.baiJamurjee}
            onChange={setSelectedTab}
            index={selectedTab}
          >
            <TabList>
              <HStack w={'100%'} justifyContent={'space-between'}>
                {/* filtersss */}
                  <Box width={"30%"}>
                    <DropdownComponent
                    options={dropdownOptions}
                    selected={selectedFilter}
                    setSelected={option => {
                      setSelectedFilter(option);
                      setChartStatusFilters(FILTER_OPTIONS_TO_CHART_STATUS_MAP[option.value])
                      getAllCharts.loadPageByFilterParams(DASHBOARD_PAGE_NAME, DASHBOARD_TABLE_NAME, {chart_statuses: FILTER_OPTIONS_TO_CHART_STATUS_MAP[option.value]})
                    }}
                    placeholder=''
                    isClearable={false}
                    isSearchable={false}
                    isDisabled={isAllChartsLoading}
                    isLoading={isAllChartsLoading}
                    />
                  </Box>
                {/* <HStack spacing={4} px={4}>
                  {auditorPortalTabs.map((apt, i) => {
                    return (
                      <Box position={'relative'}>
                        <CustomTab
                          key={`assigned-audit-tab-${i}`}
                          color={AppColors.secondary}
                          fontFamily={FONT_FAMILY.baiJamurjee}
                        >
                          {apt.title}
                          {apt.title === 'URGENT' &&
                          auditUrgentListCount > 0 ? (
                            <UrgentIcon
                              style={{ position: 'absolute', left: 90, top: 2 }}
                            />
                          ) : null}
                        </CustomTab>
                      </Box>
                    );
                  })}
                </HStack> */}
                <Box>
                  <TextInput
                    borderRadius={'md'}
                    value={onSearchText}
                    onChange={e => onFilterChange(e)}
                    onKeyDown={e => {
                      if (e.keyCode === 13) {
                        onSearchAction();
                      }
                    }}
                    mb="2"
                    rightIconProps={{ zIndex: 0 }}
                    placeholder="Search"
                    rightIcon={<SearchIcon onClick={onSearchAction} />}
                    isDisabled={isAllChartsLoading}
                  />
                </Box>
              </HStack>
            </TabList>

            <TabPanels>
              {auditorPortalTabs.map((apt, i) => {
                return (
                  <TabPanel p={0} key={`assigned-audit-panel-${i}`}>
                    <apt.component 
                    key={`my-charts-panel-${i}`} 
                    onOpenNotes={onOpenNotes} 
                    PAGE_NAME={DASHBOARD_PAGE_NAME} 
                    TABLE_NAME={DASHBOARD_TABLE_NAME}
                    />
                  </TabPanel>
                );
              })}
            </TabPanels>
          </Tabs>
        </Box>
      </CQContainer>
    </Box>
  );
};

export default withMultiProviders(
  [MyAuditProvider, AuditSheetProvider],
  DashboardContainerV2
);
